export const comments_3296174 = {"data":{"data":[],"links":{}}}